import { Component, OnInit } from '@angular/core';
import { AwsService } from '../../providers/appsyncservice/aws.service';

@Component({
  selector: 'app-completeinfo',
  templateUrl: './completeinfo.component.html',
  styleUrls: ['./completeinfo.component.css']
})
export class CompleteinfoComponent implements OnInit {

  soscount = 0;
  compdrivercount = 0;
  runningcount=0;
  markers = 0;
  scheduled =0;

  constructor(public awserviceProvider: AwsService) {

    this.configureSOS();
    this.getCompletedDataCount();
   }

  ngOnInit() {
  }

  configureSOS() {
 this.awserviceProvider.getOpenSos().then(sosdata => {
      this.soscount = sosdata.length
    })
  }

  getCompletedDataCount() {
    let dateFormat = require('dateformat');
    let now = new Date();
    let today = dateFormat(now, "yyyy-mm-dd");
    now.setDate(now.getDate() + 1);
    let tomorrow = dateFormat(now, "yyyy-mm-dd");

    var that = this
    this.awserviceProvider.getTripsByStatusCnt(2,tomorrow).then(finished => {
      let finishedlst: any = finished;
      this.compdrivercount  = finishedlst.length

    })
    this.awserviceProvider.getTripsByStatusCnt(1,today).then(running => {
      let runninglst: any = running;
      this.runningcount  = runninglst.length

    })
    
  }

}
